var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "banner_new_inner", style: _vm.Styles },
    [
      _c(
        "el-carousel",
        {
          attrs: {
            trigger: "click",
            "initial-index": _vm.initialIndex,
            height: _vm.imgHeight + "rem",
            arrow: _vm.value.config.value.length < 2 ? "never" : "hover",
            "indicator-position": "none",
          },
          on: { change: _vm.changeCarousel },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c("el-carousel-item", { key: index }, [
            _c(
              "div",
              {
                class: ["banner-img", !item.imageurl && "err"],
                style: { backgroundImage: "url(" + item.imageurl + ")" },
              },
              [
                !item.imageurl
                  ? _c("i", { staticClass: "el-icon el-icon-picture" })
                  : _vm._e(),
              ]
            ),
          ])
        }),
        1
      ),
      _vm.value.config.value.length > 2
        ? _c(
            "div",
            {
              class: ["initial", "initial" + _vm.value.config.indicator_style],
              style: {
                "z-index": _vm.value.config.z_index + 1,
                "padding-bottom": _vm.initialPadding,
              },
            },
            [
              _vm.value.config.indicator_style == 2
                ? _c("div", { staticClass: "indicator_bg" }, [
                    _c("div", { staticClass: "inner" }),
                  ])
                : _vm._l(_vm.value.config.value, function (_, index) {
                    return _c("span", {
                      key: index,
                      class: ["dot", _vm.initialIndex === index && "active"],
                      on: {
                        click: function ($event) {
                          return _vm.changeCarousel(index)
                        },
                      },
                    })
                  }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }